module.exports = __webpack_public_path__ + "static/media/tunnel2.ef70ff3b.png";